import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get } from 'lodash';

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsPayBalanceSteps defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { memberDetailsPayBalanceStepsWidgetService } from 'services/memberDetailsPayBalanceSteps';
 *
 * // create service instance and send/cancel request
 * const memberDetailsPayBalanceStepsWidgetService = new memberDetailsPayBalanceStepsWidgetService();
 * const result = await memberDetailsPayBalanceStepsWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsPayBalanceStepsWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsPayBalanceStepsWidgetService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {

            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
            const actions = get( response, 'body.component.structure.actions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                    actions: getVisibleItems( actions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // submit step data
    async submitSelectionData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );

            // handle failure
            if( SERVICE_RESPONSE_STATUS.FAILURE === get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ) ) {
                return {
                    status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                    data: {
                        description: get( response, 'body.component.data.description', {} ),
                    }
                };
            }
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.structure', {} ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

}
